// ─────────────────────────────────────────────
// Landing Page JavaScript
// ─────────────────────────────────────────────

import './index.scss';

// Set current year in footer
const yearElement = document.getElementById('current-year');
if (yearElement) {
    yearElement.textContent = new Date().getFullYear().toString();
}

// Smooth scrolling for anchor links
document.querySelectorAll('a[href^="#"]').forEach(anchor => {
    anchor.addEventListener('click', function (this: HTMLAnchorElement, e) {
        e.preventDefault();
        const target = document.querySelector(this.getAttribute('href') || '');
        if (target) {
            target.scrollIntoView({
                behavior: 'smooth',
                block: 'start'
            });
        }
    });
});

// Add scroll effect to navbar
const nav = document.querySelector('nav');
if (nav) {
    window.addEventListener('scroll', () => {
        const currentScroll = window.pageYOffset;
        if (currentScroll > 100) {
            (nav as HTMLElement).style.boxShadow = '0 2px 20px rgba(0, 0, 0, 0.15)';
        } else {
            (nav as HTMLElement).style.boxShadow = '0 2px 20px rgba(0, 0, 0, 0.1)';
        }
    });
}

